import { PiCheckCircle } from 'react-icons/pi';
import { Button } from 'rizzui';

export function GetQuoteSuccess({
  onReset,
  requestedService,
}: {
  onReset: () => void;
  requestedService?: string;
}) {
  return (
    <section
      className="quote-form-success"
      aria-labelledby="quote-form-success-title"
      role="status"
    >
      <PiCheckCircle className="quote-form-success__icon" aria-hidden="true" />
      <p className="quote-form-success__eyebrow">Message sent</p>
      <h2 id="quote-form-success-title">Thank you for contacting us.</h2>
      <p>
        Your{requestedService ? ` ${requestedService}` : ''} request has been
        sent to our logistics team. They will review the shipment details and
        contact you about the next step.
      </p>
      <Button
        type="button"
        variant="outline"
        className="quote-form-success__action"
        onClick={onReset}
      >
        Send another request
      </Button>
    </section>
  );
}
